module.exports = __webpack_public_path__ + "img/m_4.2c2d9c7d.png";